// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.wrapper-tab-when-to-travel .lad-country--weather{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;grid-row-gap:20px;row-gap:20px;margin-top:20px}section.wrapper-tab-when-to-travel .lad-country--weather .el-card__body{min-height:365px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
